import type { SharedZoomRange } from "@capacit-com/lara-law-shared-ui/pdf-viewer";

/**
 * The API prints a spreadsheet's rows across one page at full size (LAR-490),
 * so a wide sheet gets a wide page. Fit-page would shrink that page, and its
 * 11 pt text with it, to a few pixels; instead a sheet opens at fit-width held
 * between 125 % (EmbedPDF's 100 % is one CSS pixel per PDF point, so 11 pt is
 * ~14 px and 10 pt 12.5 px) and 150 %, and a wide sheet scrolls sideways.
 */
export const SPREADSHEET_ZOOM_RANGE: SharedZoomRange = { min: 1.25, max: 1.5 };
